import { API_URL } from "../../constants/axios";
import {fetchApi} from "../fetch";

export const listCreditHistory = async (creditType) => {
  const res = await fetchApi.get(API_URL.BILLING_HISTORY + `?creditType=${creditType}`);
  return res.data;
};

export const getCreditHistory = async (id) => {
  const res = await fetchApi.get(`${API_URL.GET_BILLING_HISTORY.replace("{id}", id)}`);
  return res.data;
};

export const requestTossBilling = async (customerKey, authKey) => {
  const res = await fetchApi.get(API_URL.TOSS_BILLING + `?customerKey=${customerKey}&authKey=${authKey}`);
  return res.data;
};

